import { render, staticRenderFns } from "./changecover.vue?vue&type=template&id=25d8b071&scoped=true&"
import script from "./changecover.vue?vue&type=script&lang=js&"
export * from "./changecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8b071",
  null
  
)

export default component.exports